export enum ExpenseType {
    'ALLOWANCE' = 'allowance',
    'EXPENSE' = 'expense',
}
